/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-02-03 16:35:50
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-08-07 17:33:59
 * @FilePath: \crm-product\found\views\tpm\views\budget\budget_fee_adjust\table\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import BasePage from '../../../../../../components/table_page';
import Form from '../form';
import {
  ProcessLog,
} from '../../../../../../modules';
import request from '../../../../../../utils/request';

export default {
  name: 'budget_fee_adjust',
  extends: BasePage,
  data() {
    return {};
  },
  components: {
    Form,
    ProcessLog,
  },
  created() {
    this.getConfigList('main-list');
  },
  methods: {
    // 控制按钮显示
    clickVisible({
      row,
      val: {
        code,
      },
    }) {
      const {
        processStatus,
        processNo,
      } = row;
      // 审批通过 approved,审批中 approving,活动关闭 closed,流程追回 interrupt,驳回 rejected
      if (code === 'process_log' && !processNo) {
        return false;
      }
      if (
        processStatus
        && code === 'edit'
        && (processStatus === '1'
          || processStatus === '2')
      ) {
        return false;
      }
      if (
        processStatus
        && code === 'submit_approval'
        && (processStatus === '1'
          || processStatus === '2')
      ) {
        return false;
      }
      return true;
    },
    modalClick({
      val,
      row,
    }) {
      this.formConfig = {
        ...this.formConfig,
        code: val.code,
        row,
      };
      if (val.code === 'add' || val.code === 'edit' || val.code === 'view') {
        this.modalConfig.title = val.name || '查看';
        this.openFull();
      } else if (val.code === 'process_log') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row: {
            processNo: row.processNo,
          },
        };
        this.modalConfig.title = '流程日志';
        this.formName = 'ProcessLog';
        this.openDrawer();
      }
    },
    // 提交审批回调
    onSubmit(params) {
      const configParams = {
        ...params,
        code: 'approve',
      };

      this.$emit('approve', configParams);
    },

  },
};
